import { render } from "./SideBarInfoLinks.vue?vue&type=template&id=1255783b"
import script from "./SideBarInfoLinks.vue?vue&type=script&lang=js"
export * from "./SideBarInfoLinks.vue?vue&type=script&lang=js"

import "./SideBarInfoLinks.vue?vue&type=style&index=0&id=1255783b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__